export const engagementPrediction = "/engagement/prediction_data(/:prediction_id)";
